import React, { useId, useRef } from "react";

const Tabs = ({ options, value, onChange, label, idPrefix }) => {
  const generatedId = useId();
  const prefix = idPrefix || generatedId;
  const tabList = useRef(null);

  const handleKeyDown = (event, index) => {
    let nextIndex;
    switch (event.key) {
      case "ArrowRight":
        nextIndex = (index + 1) % options.length;
        break;
      case "ArrowLeft":
        nextIndex = (index - 1 + options.length) % options.length;
        break;
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = options.length - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    onChange(options[nextIndex].value);
    tabList.current?.querySelectorAll('[role="tab"]')[nextIndex]?.focus();
  };

  return (
    <div
      ref={tabList}
      role="tablist"
      aria-label={label}
      className="photon-segments flex flex-wrap gap-1 rounded-lg bg-fill-gray-100 dark:bg-fill-panel-surface p-1 w-fit"
    >
      {options.map((option, index) => {
        const Icon = option.Icon;
        return (
          <button
            key={option.value}
            role="tab"
            id={`${prefix}-${option.value}-tab`}
            aria-controls={`${prefix}-${option.value}-panel`}
            aria-selected={value === option.value}
            tabIndex={value === option.value ? 0 : -1}
            onClick={() => onChange(option.value)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            className={`inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-xs font-medium transition-colors ${value === option.value
              ? "border-transparent bg-fill-white text-ink-ink shadow-sm dark:bg-fill-editor-surface dark:text-ink-white"
              : "border-transparent bg-transparent text-ink-gray-500 hover:text-ink-gray-700 dark:text-ink-gray-400 dark:hover:text-ink-gray-200"}`}
            type="button"
          >
            {Icon && <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />}
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
